<ng-container *ngIf="action$ | async as action">
  <div [pTooltip]="action.tooltip || action.description" tooltipPosition="top" style="display: inline-block;">
    <p-button
      [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
      [ngClass]="action.name"
      [label]="action.description"
      ntapDebounceClick
      (onClick)="executeAction($event)"
      [disabled]="(isDisabled$ | async) ?? true"
      [pTooltip]="action.tooltip ?? ''"
      tooltipPosition="left"
    ></p-button>
  </div>
</ng-container>
<ng-container *ngIf="showDialog">
  <p-dialog
    [resizable]="false"
    [(visible)]="showDialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{width: '100vw', height: '100vh'}"
    appendTo="body"
  >
    <h2>Odaberite fizički objekt</h2>
    <app-odaberi-fizicki (itemSelected)="onSelectedItem($event)"></app-odaberi-fizicki>
  </p-dialog>
</ng-container>